import { isLocalhost, isProduction, ObFlowService, SentryService } from '@web_opxp/features';
import { LanguageService } from '@web_opxp/language';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { HistoryService } from 'web_core_library';
import ENV, { BuildID } from './base/env';
import './index.scss';
import { router } from './router';

if (!isLocalhost) {
  SentryService.initSentry(isProduction(), BuildID);
}
if (!isProduction()) {
  SentryService.enableReplay();
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found. Can not start the application!');
}
const root = createRoot(container);

HistoryService.initialize(router, {
  loginBaseUrl: ENV.LoginUrl,
  logoutBaseUrl: ENV.LogoutUrl,
  BlogBaseUrl: ENV.BlogPath,
  getLanguageFunction: () => LanguageService.getLanguage() as string,
  OnboardingAppPath: ENV.OnboardingAppPath,
  SocialAppPath: ENV.SocialAppPath,
  SubscribeUrl: '/',
  TrainingBaseUrl: ENV.TrainingAppPath,
  signupBaseUrl: ENV.RegistrationUrl,
});

const searchParams: URLSearchParams = HistoryService.getCurrentSearchParams();

ObFlowService.init('subscribe', searchParams, ENV.AssetsBaseUrl, {
  getExternalUrl: HistoryService.getExternalUrl,
  getInternalUrl: HistoryService.getInternalUrl,
  getRegistrationUrl: HistoryService.getSignupUrl,
  redirectExternal: HistoryService.externalRedirect,
  redirectInternal: HistoryService.redirectInternal,
  redirectRegistration: HistoryService.redirectSignup,
  urlMap: {
    training: ENV.TrainingAppPath,
    sso: ENV.AuthBaseUrl,
    onboarding: ENV.OnboardingAppPath,
    user: ENV.UserAppPath,
    mobileDownload: `${ENV.TrainingAppPath}/app-download`,
  },
});

root.render(<RouterProvider router={router} />);
